import { jsx as _jsx } from "react/jsx-runtime";
import MuiFab from '@mui/material/Fab';
import * as React from 'react';
import { withVersion } from '../utils';
// TODO: replace this with Rubiks component when design exists
export const Fab = withVersion((props) => _jsx(MuiFab, { "data-role": "fab", ...props }), '1.0.0');
